import type { RouteObject } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import { ADMINISTRATOR } from '@/shared/guards/roles';
import { DeliveriesPage } from './pages/DeliveriesPage';

/**
 * Sub-árvore de rotas do módulo de Entregas (Delivery Admin). Gateado por
 * `ADMINISTRATOR` — espelha o `@Roles('adminDashboard.administrator')` do
 * `DeliveryAdminReadController` no monolith (o gating do front é só UX; o back
 * é a autoridade real).
 */
export const deliveryRoutes: RouteObject[] = [
  {
    element: <RoleGuard roles={[ADMINISTRATOR]} />,
    children: [{ path: 'delivery', element: <DeliveriesPage /> }],
  },
];
